import React, { useState, useEffect } from "react";
import axios from "axios";

const ImageWithAuthModal = ({ imageName, apiBaseUrl, token, openImageModal }) => {
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    const fetchImageUrl = async () => {
      try {
        const response = await axios.get(`${apiBaseUrl}file/${imageName}`, {
          headers: {
            Authorization: `Bearer ${token}`, 
          },
        });

        const url = response.request.url || response.data.url;
        setImageUrl(url);
      } catch (error) {
        console.error("Error fetching image:", error);
      }
    };

    fetchImageUrl();
  }, [imageName, apiBaseUrl, token]);

  const handleClick = () => {
    if (imageUrl) {
      openImageModal(imageUrl);
    }
  };

  if (!imageUrl) {
    return <p>Loading image...</p>;
  }

  return (
    <img
      src={imageUrl}
      alt={imageName}
      onClick={handleClick}
      style={{ cursor: "pointer", maxWidth: "200px", borderRadius: "5px" }}
    />
  );
};

export default ImageWithAuthModal;
